module.exports = __webpack_public_path__ + "static/media/button-google-play@3x.54bdf578.png";